// src/directives/lowercase.js
export default {
    beforeMount(el) {
      el.addEventListener('input', () => {
        // guardo la posición actual
        const start = el.selectionStart
        const end   = el.selectionEnd
  
        // calculo el nuevo valor
        const val   = el.value
        const lower = val.toLowerCase()
        if (lower === val) return
  
        // actualizo el input y restauro el caret
        el.value = lower
        el.setSelectionRange(start, end)
        // disparo manualmente el evento para que v-model se entere
        el.dispatchEvent(new Event('input'))
      })
    }
  }
  